// extracted by mini-css-extract-plugin
export default {"PhotoSelectContainer":"PhotoSelect_PhotoSelectContainer__ZsEeQ","ImageSection":"PhotoSelect_ImageSection__Z5n30"};